export const ERROR_MESSAGE = 'Something went wrong, please try again later';
